<h5 mat-dialog-title>Color palette</h5>
<div fxLayout mat-dialog-content fxLayoutGap="60px">
    @for (paletteName of palettes; track $index) {
        <div>
            <p class="m-x-0">{{ paletteName }} color</p>
            @for (hue of hues; track $index) {
                <div class="p-a-sm" fxLayoutAlign="end center">
                    <p class="m-y-0">{{ hue }}:</p>
                    <input type="color" #color appendColor [id]="paletteName + '-' + hue" />
                </div>
            }
        </div>
    }
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="copyColorsJson()">Copy colors json</button>
</div>
